import React from "react";
import { NavLink, Outlet, Route, Routes } from "react-router-dom";
import styled from "styled-components";
import Footer from "../../components/Footer";
import CategoryColumn from "../../components/Home/CategoryColumn";
import Header from "../../components/Navbar";
import EditProfile from "../../components/Profile/EditProfile";
import Profile from "../../components/Profile/Profile";
import ProfileInfo from "../../components/Profile/ProfileInfo";
import Container from "../../UI/Container";

function ProfilePage() {
  return (
    <Wrapper>
      <Header />
      <div className="devider"></div>
      <Outlet />
      <Footer />
    </Wrapper>
  );
}

export default ProfilePage;
const Wrapper = styled.main`
  .main-title {
    div {
      gap: 10px;
    }
    .edit {
      cursor: pointer;
      &:hover {
        background-color: #8dd1f8;
      }
    }
    h2 {
      margin-bottom: 0;
    }
  }
`;
